export interface WicketApiUserField {
  created_at: string;
  data_value: string;
  fk_dict_user_data_type_id: number;
  fk_fan_id: number;
  id: number;
}
